/* eslint-disable @typescript-eslint/naming-convention */
import { Component, Input, OnInit } from '@angular/core';
import { HelperService } from 'src/app/services/helper/helper.service';
import { SmartDatePipe } from 'src/app/pipes/smart-date.pipe';

interface Flight {
  srcName: string;
  destName: string;
  src: string;
  dep_time_str: string;
  depDayDate: string;
  dest: string;
  arr_time_str: string;
  airline_name: string;
  duration: string;
  sourceTerminal: string;
  sourceGate: string;
  destGate: string;
  destTerminal: string;
}
@Component({
  selector: 'flight-card',
  templateUrl: './flight-card.component.html',
  styleUrls: ['./flight-card.component.scss'],
})
export class FlightCardComponent implements OnInit {
  @Input() upcomingFlight: any;
  constructor(
    public helperService: HelperService,
    private smartDatePipe: SmartDatePipe
  ) {}

  ngOnInit() {
    console.log(this.upcomingFlight);
  }

  calculateTotalTime(departureTime: any, arrivalTime: any) {
    const [h, m] = this.helperService.calculateTravelDuration(
      departureTime,
      arrivalTime
    );
    if (!isNaN(h) && !isNaN(m)) {
      return `${h}h ${m}m`;
    }
    return '';
  }

  getTime(date: any) {
    if (date) {
      return this.smartDatePipe.transform(date, 'HH:mm');
    }
    return '';
  }

  datesDiffer(date1, date2) {
    if (!date1 || !date2) {
      return false;
    }
    return date1.getTime() !== date2.getTime();
  }

  isExpectedActualDep(airportDetails) {
    if (!airportDetails?.actual_dep && !airportDetails?.expected_dep) {
      return false;
    }
    const scheduled = new Date(airportDetails?.scheduled_dep);

    if (airportDetails?.actual_dep) {
      const actual = new Date(airportDetails?.actual_dep);
      if (actual && this.datesDiffer(actual, scheduled)) {
        return airportDetails?.actual_dep;
      }
    }

    if (airportDetails?.expected_dep) {
      const expected = new Date(airportDetails?.expected_dep);
      if (expected && this.datesDiffer(expected, scheduled)) {
        return airportDetails?.expected_dep;
      }
    }
    return false;
  }

  isExpectedActualArr(airportDetails) {
    if (!airportDetails?.actual_arr && !airportDetails?.expected_arr) {
      return false;
    }
    const scheduled = new Date(airportDetails?.scheduled_arr);

    if (airportDetails?.actual_arr) {
      const actual = new Date(airportDetails?.actual_arr);
      if (actual && this.datesDiffer(actual, scheduled)) {
        return airportDetails?.actual_arr;
      }
    }

    if (airportDetails?.expected_arr) {
      const expected = new Date(airportDetails?.expected_arr);
      if (expected && this.datesDiffer(expected, scheduled)) {
        return airportDetails?.expected_arr;
      }
    }
    return false;
  }
}
